import { useNavigate, useSearch } from '@tanstack/react-router';

import { parseDemandPartnersRouteSearch, serializeDemandPartnersRouteSearch } from './routeSearch';
import type {
  DemandPartnerSortDirection,
  DemandPartnerSortProperty,
  DemandPartnerStatus,
} from './model';

export function useDemandPartnersRouteFilters() {
  const navigate = useNavigate({ from: '/demand/partners/' });
  const search = useSearch({ from: '/demand/partners/' });
  const filter = parseDemandPartnersRouteSearch(search);
  const update = (next: typeof filter) => {
    void navigate({ search: serializeDemandPartnersRouteSearch(next), replace: true });
  };
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: DemandPartnerStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setSort: (
      sortProperty: DemandPartnerSortProperty | null,
      sortDirection: DemandPartnerSortDirection,
    ) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
